import { useEffect, useRef, useState } from 'react';

interface UseInViewportOptions {
  threshold?: number;
  rootMargin?: string;
  triggerOnce?: boolean;
}

export const useInViewport = <T extends HTMLElement>(
  options: UseInViewportOptions = {}
): { ref: React.RefObject<T>; isInViewport: boolean; hasBeenInViewport: boolean } => {
  const { threshold = 0, rootMargin = '0px', triggerOnce = false } = options;
  const [isInViewport, setIsInViewport] = useState(false);
  const [hasBeenInViewport, setHasBeenInViewport] = useState(false);
  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const inViewport = entry.isIntersecting;
        setIsInViewport(inViewport);

        if (inViewport && !hasBeenInViewport) {
          setHasBeenInViewport(true);
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [threshold, rootMargin, hasBeenInViewport]);

  // triggerOnce가 true이고 이미 뷰포트에 있었다면 false 반환
  const shouldShow = triggerOnce ? hasBeenInViewport : isInViewport;

  return { ref, isInViewport: shouldShow, hasBeenInViewport };
};
